import { render, staticRenderFns } from "./DictPositionListPage.vue?vue&type=template&id=79a3c5c7&"
import script from "./DictPositionListPage.vue?vue&type=script&lang=ts&"
export * from "./DictPositionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports